<template>
  <div class="fade-in">
    <onboarding-loading
      v-if="isLoading"
      :loadingText="loadingMessage"
      :onErrorGoTo="'onboarding-error'"
    />

    <ContractView v-else :ccbUrl="myCCBUrl" @click="sendAcceptContract" />

    <GenericModal name="generic-modal" loadingText="Contrato Assinado" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ContractView from '../../../components/onboarding/ContractView.vue';
import GenericModal from '../../portal/components/Molecules/GenericModal.vue';
import OnboardingLoading from '../components/OnboardingLoading.vue';

export default {
  name: 'v2-onboarding-signature-contract-view',
  components: {
    GenericModal,
    OnboardingLoading,
    ContractView,
  },
  data() {
    return {
      isLoading: true,
      loadingMessage: 'Carregando contrato...',
      myCCBUrl: '',
    };
  },
  computed: {
    ...mapGetters('onboardingV2', ['ccbUrl']),
  },
  methods: {
    ...mapActions('onboardingV2', ['setLoading', 'acceptContract']),
    async sendAcceptContract() {
      try {
        this.isLoading = true;
        await this.acceptContract();
        this.isLoading = false;

        this.$modal.show('generical-modal');
        this.handleNextStep();
      } catch {
        this.$router.replace({
          name: 'v2-onboarding-error',
          query: this.$route.query,
        });
      }
    },
    handleNextStep() {
      setTimeout(() => {
        this.$modal.hide('generical-modal');
        this.$router.replace({
          name: 'v2-onboarding-desk',
          query: this.$route.query,
        });
      }, 3000);
    },
  },
  async mounted() {
    try {
      const output = await fetch(`${this.ccbUrl}?returnUrl=true`);
      this.myCCBUrl = (await output.json()).url;
    } catch (err) {
      this.$router.replace({
        name: 'onboarding-error',
        query: this.$route.query,
      });
    }

    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
  },
};
</script>

<style lang="scss" scoped>
</style>
